import type { Climb } from '../../types/climb';

export type ClimbListLocationType = 'gym' | 'competition' | 'crag';

/**
 * Where a climb picked from the list it was opened from lives: a board problem
 * under its board when the list was the board's, the rest under their type
 * segment of the place. Shared by the swipe (ClimbNavigation) and the list in
 * the breadcrumb (ClimbsListDrawer), so both land on the same page.
 */
export function climbListPath(
  climb: Pick<Climb, 'type' | 'slug'>,
  locationSlug: string,
  { boardId, locationType = 'gym' }: { boardId?: string; locationType?: ClimbListLocationType } = {}
): string {
  if (climb.type === 'BoardClimb' && boardId) return `/gyms/${locationSlug}/boards/${boardId}/climbs/${climb.slug}`;

  const climbType = climb.type === 'Route' ? 'routes' : 'boulders';
  const basePath = locationType === 'competition' ? 'competitions' : locationType === 'crag' ? 'crags' : 'gyms';
  return `/${basePath}/${locationSlug}/${climbType}/${climb.slug}`;
}
